/* eslint-disable prefer-destructuring */

import axios from 'axios'
import https from 'https'

const httpsAgent = new https.Agent({ rejectUnauthorized: false })

export type ConsulDataResponse = [
  {
    LockIndex: number
    Key: string
    Flags: number
    Value: string
    CreateIndex: number
    ModifyIndex: number
  }
]

export const getConsulData = async (endpoint: string) => {
  const consulHost = process.env.CONSUL_HOST
  const consulPort = process.env.CONSUL_PORT
  const consulPath = process.env.CONSUL_PATH
  const consulToken = process.env.CONSUL_TOKEN

  if (!consulHost) {
    throw new Error('CONSUL_HOST is empty — use npm run start:local (sourcet .vars) or set CONSUL_*')
  }

  const baseUrl = `${consulHost}:${consulPort}/v1/kv`
  const url = `${baseUrl}/${consulPath}/cyber-shopwindow${endpoint}`

  const response = await axios.get<ConsulDataResponse>(url, {
    httpsAgent,
    headers: {
      'X-Consul-Token': consulToken,
    },
  })

  return response.data
}
